var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDance = function SvgDance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.2 477.7v-26.2c0-34.6 17.1-68.1 45.6-88 20.7 51.1 51.4 99 88.8 136.4 6.1 6.1 14.1 9.1 22.1 9.1 8 0 16-3 22.2-9.2 12.2-12.2 12.2-32.1 0-44.3-64.5-64.4-82.9-136.6-84.7-140.5v-85.2c46.1 10.7 81.8 45.6 93.2 91.2l1.7 6.7c4.1 16.4 21.3 26.8 38 22.7 16.8-4.2 26.9-21.2 22.7-38l-1.7-6.7c-20.9-83.8-95.8-142.2-182.2-142.2-.6 0-1.1-.1-1.6-.1 33.9-.8 61.2-28.4 61.2-62.5 0-34.5-28.1-62.6-62.6-62.6s-62.6 28.1-62.6 62.6c0 30 21.3 55.1 49.5 61.2-52.4-6.9-96-46.3-106.6-99.2L138 31.1c-8.2-41-69.6-28.3-61.4 12.3l6.1 31.8c14.9 74.3 75 133.7 149.8 147.7v76.3c-57.9 28.6-93.9 87.6-93.9 152.3v26.2c0 17.3 14 31.3 31.3 31.3s31.3-14 31.3-31.3z"
  })));
};

export default SvgDance;